"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIClient = void 0;
var HTTPClient_1 = require("./HTTPClient");
var APIClient = /** @class */ (function () {
    function APIClient(http) {
        var _this = this;
        this.http = http;
        this.entry = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.cachedEntryPromise) {
                    this.cachedEntryPromise = this.http.request({ url: '/', headers: { accept: 'application/vnd.innerhive.entry.v1+json' } })
                        .then(function (_a) {
                        var data = _a.data;
                        return data;
                    })
                        .catch(function (e) {
                        _this.cachedEntryPromise = undefined;
                        throw e;
                    });
                }
                return [2 /*return*/, this.cachedEntryPromise];
            });
        }); };
        // Used by tests that request a re-fetch to see new links
        this.clearEntryCache = function () {
            _this.cachedEntryPromise = undefined;
        };
        this.delete = function (resourceOrLink, params) { return __awaiter(_this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrlFromResourceOrLink(resourceOrLink);
                        if (params) {
                            url = this.substituteParams(url, params);
                        }
                        return [4 /*yield*/, this.http.request({ url: url, method: 'DELETE' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.put = function (resourceOrLink, data, headers, params) { return __awaiter(_this, void 0, void 0, function () {
            var url, dataOrResource, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrlFromResourceOrLink(resourceOrLink);
                        url = this.substituteParams(url, params || data);
                        dataOrResource = (!data && resourceOrLink.links) ? resourceOrLink : data;
                        return [4 /*yield*/, this.http.request({ url: url, data: dataOrResource, headers: headers, method: 'PUT' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.patch = function (resourceOrLink, data, headers, params) { return __awaiter(_this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrlFromResourceOrLink(resourceOrLink);
                        url = this.substituteParams(url, params || data);
                        return [4 /*yield*/, this.http.request({ url: url, data: data, headers: headers, method: 'PATCH' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.post = function (resourceOrLink, data, headers, params) { return __awaiter(_this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrlFromResourceOrLink(resourceOrLink);
                        url = this.substituteParams(url, params || data);
                        return [4 /*yield*/, this.http.request({ url: url, data: data, headers: headers, method: 'POST' })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.get = function (resourceOrLink, accept, params, options) { return __awaiter(_this, void 0, void 0, function () {
            var headers, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = accept ? { accept: accept } : undefined;
                        url = this.getUrlFromResourceOrLink(resourceOrLink);
                        url = this.substituteParams(url, params);
                        return [4 /*yield*/, this.http.request({ url: url, headers: headers, method: 'GET', options: options })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.getUrlFromResourceOrLink = function (resourceOrLink) {
            // if it looks like a resource, return self link
            if (resourceOrLink.links && resourceOrLink.links.self) {
                return resourceOrLink.links.self.href;
            }
            // if it looks like a link, return the url
            if (resourceOrLink.href) {
                return resourceOrLink.href;
            }
            // if it's a string, assume it's the url
            if (typeof resourceOrLink === 'string') {
                return resourceOrLink;
            }
            // otherwise throw
            throw new Error("Could not find a url in ".concat(JSON.stringify(resourceOrLink)));
        };
        this.substituteParams = function (url, params) {
            if (params === void 0) { params = {}; }
            if (url.includes('[[')) {
                url = url.replace(/\[\[(.+?)\]\]/g, function (_match, key) {
                    if (key.endsWith('?')) {
                        // substitute optional [[key?]] with the matching value from params or empty string
                        var name_1 = key.slice(0, -1); // remove "?" from end
                        return encodeURIComponent(params[name_1] || '');
                    }
                    else {
                        // substitute required [[key]] with the matching value from params
                        if (!params[key]) {
                            throw new Error("Missing required param \"".concat(key, "\""));
                        }
                        return encodeURIComponent(params[key]);
                    }
                });
            }
            return url;
        };
    }
    APIClient.inject = function () { return [HTTPClient_1.HTTPClient]; };
    return APIClient;
}());
exports.APIClient = APIClient;
//# sourceMappingURL=APIClient.js.map